"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageMerchModuleLayouts = void 0;
exports.SetPageMerchModuleLayouts = [
    "image-links",
    "card-swiper",
    "image-buttons-right",
    "image-buttons-left",
];
//# sourceMappingURL=Merch.js.map